module.exports = __webpack_public_path__ + "img/bocata.bda94c81.jpeg";